import "./help.scss";

import { motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { useIsTouchDevice } from "@client/hooks/useIsTouchDevice";

export const Help = observer(() => {
	const questionOptions = [
		{
			id: 0,
			question: "החנות שלי מופיעה כ- closed, למה ?",
			answer:
				"במהלך תהליך ההתחברות לטרמינל איקס סיפקתם את שעות הפעילות של החנות. החנות תופיע כפתוחה ותקבל הזמנות רק במהלך שעות הפעילות שסופקו. אם ברצונכם לשנות את שעות הפעילות יש לפנות לשירות השותפים.",
		},
		{
			id: 1,
			question: "באיזה שעות המלאי מתעדכן באתר ?",
			answer:
				"תהליך עדכון המלאי באתר מתחיל כל יום בשעה 11:00 על בסיס האקסל שמועבר לטרמינל איקס. התהליך עלול לקחת מספר שעות עד אשר יתעדכן באתר בצורה מלאה.<br/>2 נקודות חשובות :<br/>• במידה ולא עודכן קובץ המלאי עד השעה 10:00 הפריטים לא יתעדכנו באתר<br/>• קיימים תהליכים במערכת שנועדים להבטיח הופעת מלאי מדויק ללקוחות. ייתכן מצב שבו מלאי שעודכן בקובץ לא יראה באתר",
		},
		{
			id: 2,
			question: "איזה דוחות ניתן לקבל בצורה אוטומטית מהמערכת ?",
			answer:
				"כיום ניתן לקבל את הדוחות הבאים בצורה אוטומטית<br/>התראה במייל על כל הזמנה חדשה (יש לפנות לשירות השותפים לטובת הגדרה) •<br/>התראה מרכזת במייל על הזמנות חדשות (אחת למספר שעות קבלת אקסל עם כלל ההזמנות הפתוחות •",
		},
		{
			id: 3,
			question: "מה יקרה להזמנות שנכנסות לאחר שעות הפעילות ?",
			answer:
				"הזמנות שנכנסות לאחר שעות הפעילות יופיעו בתחילת יום העסקים הבא. ניקח לדוגמא חנות שפתוחה בין 0900-1800. הזמנות שיכנסו בשעה 1900 יופיעו במערכת בשעה 0900 למחרת.",
		},
		{
			id: 4,
			question: "תוך כמה זמן צריך לטפל בהזמנה ?",
			answer:
				'ההתחייבות מצד הספק היא לסיים לארוז את כלל ההזמנות שהגיעו באותו יום עסקים. כלומר הזמנה שהגיע 5 דקות לפני סגירת החנות צריכה להיות מוכנה באותו יום עסקים. במידה ויש חריגה מהנ"ל נא לפנות למנהל המסחרי איתו אתם בקשר.',
		},
		{
			id: 5,
			question: "הזמנה נעלמה לי מהמסך, מה קרה ?",
			answer:
				"ברוב המוחלט של המקרים מדובר בהזמנה שבוטלה אוטומטית. האם ההזמנה הייתה קרובה לביטול? במידה ולא, ניתן לפנות לשירות השותפים אשר יכול לאחזר הזמנות ומדבקות.",
		},
		{
			id: 6,
			question: "לא יצאה מדבקה, מה לעשות ?",
			answer:
				"במקרה ובו לא יצאה מדבקה יש לעקוב אחרי הצעדים הבאים:<br/>1 - יש לנסות להדפיס בשנית דרך כפתור הprint again<br/> 2 - במידה ולא מדפיס, יש לכבות את המדפסת ולהדליק מחדש<br/>3 - במידה ולא מדפיס, יש לכבות את האייפד (ולא רק לצאת מהאפליקציה) ולהדליק מחדש<br/>4 - במידה ולא מדפיס, יש לפנות לשירות השותפים. חובה לכלול בפנייה: צילום של הודעת השגיאה ומספר ההזמנה (בצילום ו/או בכתב)",
		},
	];

	const [activeQuestionOptions, setActiveQuestionOptions] = useState<any>([]);

	const answerVariants = {
		open: { opacity: 1, height: "auto" },
		closed: { opacity: 0, height: 0 },
	};

	const blockVariants = {
		open: { marginBottom: "40px" },
		closed: { marginBottom: 0 },
	};

	const [showAnswerSection, setShowAnswerSection] = useState(false);

	function showAnswer(id: number) {
		// console.log(
		// 	"!!activeQuestionOptions.findIndex((option: any) => option.id === id)",
		// 	!!(activeQuestionOptions.findIndex((option: any) => option.id === id) + 1)
		// );
		return !!(
			activeQuestionOptions.findIndex((option: any) => option.id === id) + 1
		);
	}

	function handleBlockClick(id: number) {
		const index =
			activeQuestionOptions?.findIndex((option: any) => option?.id === id) + 1;
		// console.log("index", index);
		if (!index) {
			const addedOption = questionOptions[id];
			setActiveQuestionOptions([...activeQuestionOptions, addedOption]);
			// console.log("add", activeQuestionOptions);
		} else {
			// console.log("index -1 ", index - 1);
			activeQuestionOptions.splice(index - 1, 1);
			setActiveQuestionOptions([...activeQuestionOptions]);
			// console.log("remove", activeQuestionOptions);
		}
	}

	function handleBannerClick() {
		const isTouchDevice = useIsTouchDevice();
		if (isTouchDevice) {
			window.webkit?.messageHandlers?.openLink?.postMessage("open");
		} else {
			window.open("https://forms.gle/jrf1MNHQN1bYyT1r5");
		}
	}

	function getFormatedAnswer(answer: string) {
		if (!answer.indexOf("<br/>")) {
			return answer;
		}

		const arrOfSentences = answer.split("<br/>");

		return (
			<>
				{arrOfSentences.map((sentence) => (
					<div className="sentence" key={sentence}>
						{sentence}
					</div>
				))}
			</>
		);
	}

	return (
		<div className="help-container">
			<div className="banner" onClick={handleBannerClick}>
				<img className="banner-img" src="/images/partners_support.png" />
				<div className="banner-btn">{"פתיחת קריאה"}</div>
			</div>
			<div className="questions-container">
				<div className="questions-title">POPULAR QUESTIONS</div>
				<div className="question-options">
					{questionOptions.map((option) => (
						<motion.div
							key={option.id}
							variants={blockVariants}
							animate={showAnswer(option.id) ? "open" : "closed"}
							transition={{ bounce: 0 }}
						>
							<div
								className="question-block"
								onClick={() => handleBlockClick(option.id)}
							>
								<div className="question-block-title">{option.question}</div>
							</div>

							<motion.div
								className="answer"
								variants={answerVariants}
								initial={{ opacity: 0, height: 0 }}
								animate={showAnswer(option.id) ? "open" : "closed"}
								exit={{ opacity: 0, height: 0 }}
								style={{
									visibility: showAnswer(option.id) ? "visible" : "hidden",
								}}
							>
								{getFormatedAnswer(option.answer)}
							</motion.div>
						</motion.div>
					))}
				</div>
			</div>
		</div>
	);
});
